import { render } from "./Messages.vue?vue&type=template&id=39e3fe5d&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"

import "./Messages.vue?vue&type=style&index=0&id=39e3fe5d&scoped=true&lang=css"
import "./Messages.vue?vue&type=style&index=1&id=39e3fe5d&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e3fe5d"]])

export default __exports__